export const POSTS_STORE_MODULE_NAME = 'posts';

export const POSTS_ACTIONS = {
  createPost: `${POSTS_STORE_MODULE_NAME}/createPost`,
  modifyPost: `${POSTS_STORE_MODULE_NAME}/modifyPost`,
  deletePost: `${POSTS_STORE_MODULE_NAME}/deletePost`,
};
